import {
    AnnualTaxGroupType,
    getOverviewSectionsByType
} from "@pages/payroll/annualTaxSettlement/AnnualTaxSettlement.utils";
import {
    AnnualTaxSettlementOverviewCell,
    AnnualTaxSettlementOverviewTable
} from "@pages/payroll/annualTaxSettlement/overView/AnnualTaxSettlement.styles";
import { IOverviewBaseProps } from "@pages/payroll/payslip/overview/OverviewBase";
import { getCompanyCurrency } from "@utils/CompanyUtils";
import { memoizeOne } from "@utils/memoizeOne";
import React from "react";

import { DASH_CHARACTER } from "../../../../constants";
import CurrencyType from "../../../../types/Currency";
import { getEntityMemoKey } from "../../../../views/formView/Form.utils";
import TestIds from "../../../../testIds";
import { isDefined } from "@utils/general";

interface IProps extends IOverviewBaseProps {
    type: AnnualTaxGroupType;
}

export default class AnnualTaxSettlementOverview extends React.Component<IProps> {
    getSections = memoizeOne(() => {
        return getOverviewSectionsByType(this.props.storage, this.props.type);
    }, () => [getEntityMemoKey(this.props.storage)]);

    render(): React.ReactElement {
        return <AnnualTaxSettlementOverviewTable data-testid={TestIds.AnnualTaxSettlementOverviewTable}>
            {this.getSections().map((row, index) => (
                <React.Fragment key={index}>
                    <AnnualTaxSettlementOverviewCell data-testid={TestIds.AnnualTaxSettlementOverviewCell}>
                        {row.number}
                    </AnnualTaxSettlementOverviewCell>
                    <AnnualTaxSettlementOverviewCell $isSubRow={row.isSubRow} $isBold={row.isBold} data-testid={TestIds.AnnualTaxSettlementOverviewCell}>
                        {row.title}
                    </AnnualTaxSettlementOverviewCell>
                    <AnnualTaxSettlementOverviewCell $isBold={row.isBold} data-testid={TestIds.AnnualTaxSettlementOverviewCell}>
                        {isDefined(row.value) ? CurrencyType.format(row.value, { currency: getCompanyCurrency(this.props.storage.context) }) :  DASH_CHARACTER}
                    </AnnualTaxSettlementOverviewCell>
                </React.Fragment>
            ))}
        </AnnualTaxSettlementOverviewTable>;
    }
}
